import { render } from "./FormLocation.vue?vue&type=template&id=603ef2cc"
import script from "./FormLocation.vue?vue&type=script&lang=js"
export * from "./FormLocation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__